export default async function (page) {
  if (page._Column) {
    page._Column.items = [];
  } else {
    page._Column = { items: [] };
  }
}
